import type { Currency } from '@/config/tenants/types'

export function formatCurrency(amount: number | `${number}`, currency: Currency, locale: string): string {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  })

  return formatter.format(amount)
}
